import { type FC, useContext } from "react";
import { useParams } from "react-router-dom";

import { Button } from "@snapchat/snap-design-system";

import owlSvg from "@app-assets/svg/owl.svg";

import { type AbsoluteRoute, type RouteParams } from "../../../core/routes";
import { PageContent, PageContentSpinner } from "../../../layout/components";
import { UserInfoContext } from "../../../shared/api/contexts";
import { useSelectSubmitAccount } from "../../hooks";

import { HelpImage, SectionHeader, SelectSubmitAccountContainer, linkStyle } from "./SelectSubmitAccountPage.styles";

export const SelectSubmitAccountPage: FC = () => {
    const { submissionId = "" } = useParams<RouteParams[AbsoluteRoute.SUBMIT_ACCOUNT_SELECT]>();
    const { submitWithDifferentUser, signOut } = useSelectSubmitAccount(submissionId);

    const userInfo = useContext(UserInfoContext);

    if (!!userInfo?.loading || !userInfo?.data) {
        return <PageContentSpinner />;
    }

    const {
        getUserProfile: { userDisplayName },
    } = userInfo.data;

    return (
        <PageContent>
            <SelectSubmitAccountContainer>
                <HelpImage src={owlSvg} />
                <SectionHeader>You are submitting the Lens as {userDisplayName}</SectionHeader>
                <Button type="primary" onClick={submitWithDifferentUser}>
                    Submit with this account
                </Button>
                <Button type="link" className={linkStyle} onClick={signOut}>
                    Use a Different Account
                </Button>
            </SelectSubmitAccountContainer>
        </PageContent>
    );
};
